export const clipBoardSelectors = ({ state }) => state.ui.clipBoard;
